import { plainToClass } from 'class-transformer';
import {
  API_TASK_TYPE_CREATE,
  API_TASK_TYPE_DELETE,
  API_TASK_TYPE_FIND_ALL,
  API_TASK_TYPE_FIND_ONE,
  API_TASK_TYPE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { TaskTypeDto } from '../dto';
import { FindAllResponse } from '../types';

export class TaskTypeApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<TaskTypeDto>> {
    return this.httpClient
      .get(API_TASK_TYPE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(TaskTypeDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<TaskTypeDto> {
    return this.httpClient
      .get(API_TASK_TYPE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(TaskTypeDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<TaskTypeDto> {
    return this.httpClient.post(API_TASK_TYPE_CREATE, data).then(({ data }) => {
      return plainToClass(TaskTypeDto, data);
    });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<TaskTypeDto> {
    return this.httpClient.put(API_TASK_TYPE_UPDATE, data).then(({ data }) => {
      return plainToClass(TaskTypeDto, data);
    });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_TASK_TYPE_DELETE, {
      pathParams: { uuid }
    });
  }
}
